import { Injectable } from '@angular/core';
import { HttpClient,HttpParams,HttpHeaders } from  '@angular/common/http';
import { Organisation } from '../interface/organisation';
import { Subject,Observable } from 'rxjs';
import { tap, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class OrganisationService {
  httpOptions:any;
  httpOption:any;
  headers:any;

  private _refreshNeeded$ = new Subject<void>();

  get refreshNeeded$() {
    return this._refreshNeeded$;
  }
  
  constructor(private http:HttpClient) 
    {
      this.httpOptions = {
        headers: new HttpHeaders({
          'Content-Type':  'application/json',
          'Authorization': 'my-auth-token'
        })
      };

      this.httpOption = {
        headers: new HttpHeaders({
          'Content-Type':  'multipart/form-data',
          'Authorization': 'my-auth-token'
        })
      };

  }

  getAllOrganisation(url){
      return this.http.get(url,this.httpOptions)
  }

  getOrganisationByID(url,param){
    //return this.http.get(url,this.httpOptions)
    return this.http.post<Organisation>(url,param,this.httpOptions)
  }

  postOrganisation(url,param){
  //   return this.http.post(url, param)
  // }

    return this.http.post<Organisation>(url,param)
    .pipe(
      tap(() =>  {
        this._refreshNeeded$.next();
      })
    );
  }

  updateOrganisation(url,param){
    return this.http.put<Organisation>(url,param,this.httpOptions)
    .pipe(
      tap(() =>  {
        this._refreshNeeded$.next();
      })
    );
  }
  
  deleteOrganisationByID(url,param){
    return this.http.put<Organisation>(url,param,this.httpOptions)
    .pipe(
      tap(() =>  {
        this._refreshNeeded$.next();
      })
    );
  }


  getAllPosition(url){
    return this.http.get(url,this.httpOptions)
}
}
